export default __webpack_public_path__ + "static/media/gl-ex2.1f3803f4.jpg";